/* tslint:disable */
/* eslint-disable */
/**
 * Customer Journey Endpoints
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const FeedbackType = {
	CustomerJourney: 'CustomerJourney',
	Offer: 'Offer',
} as const;
export type FeedbackType = (typeof FeedbackType)[keyof typeof FeedbackType];

export function instanceOfFeedbackType(value: any): boolean {
	for (const key in FeedbackType) {
		if (Object.prototype.hasOwnProperty.call(FeedbackType, key)) {
			if (FeedbackType[key as keyof typeof FeedbackType] === value) {
				return true;
			}
		}
	}
	return false;
}

export function FeedbackTypeFromJSON(json: any): FeedbackType {
	return FeedbackTypeFromJSONTyped(json, false);
}

export function FeedbackTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): FeedbackType {
	return json as FeedbackType;
}

export function FeedbackTypeToJSON(value?: FeedbackType | null): any {
	return value as any;
}

export function FeedbackTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): FeedbackType {
	return value as FeedbackType;
}
